import axios from "axios";

const apiURL = process.env.REACT_APP_API_URL; // Make sure you have the environment variable set correctly

export const loginMember = async (email, password) => {
  try {
    const response = await axios.post(`${apiURL}admin/login`, {
      email: email,
      password: password,
    });

    if (response.message === "Passwords do not match") {
      throw new Error("Invalid password");
    }

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error("Invalid Email or Password!");
  }
};

